import { usePageTitle } from "@/hooks/use-page-title";
import { AuditTrail } from "@/components/audit/audit-trail";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Shield, AlertTriangle } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { ResponsiveLayout } from "@/components/layout/responsive-layout";

export default function AuditTrailPage() {
  usePageTitle("Audit Trail");
  const { user } = useAuth();

  // Check if user has admin access
  if (!user || user.role !== 'admin') {
    return (
      <ResponsiveLayout title="Audit Trail" subtitle="Monitor all system changes and user actions">
        <div className="flex items-center justify-center py-12">
          <Card className="w-full max-w-md">
            <CardHeader className="text-center">
              <div className="mx-auto mb-4 w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                <Shield className="w-6 h-6 text-red-600" />
              </div>
              <CardTitle className="text-red-800">Access Denied</CardTitle>
              <CardDescription>
                You need administrator privileges to access the audit trail.
              </CardDescription>
            </CardHeader>
          </Card>
        </div>
      </ResponsiveLayout>
    );
  }

  return (
    <ResponsiveLayout title="Audit Trail" subtitle="Monitor all system changes and user actions">
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
        <div className="flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5" />
          <div>
            <h3 className="font-medium text-amber-800">Security Notice</h3>
            <p className="text-sm text-amber-700 mt-1">
              This audit trail contains sensitive information about system changes and user activities. 
              Please ensure this data is handled according to your organization's security policies.
            </p>
          </div>
        </div>
      </div>

      <AuditTrail showFilters={true} />
    </ResponsiveLayout>
  );
}